// extracted by mini-css-extract-plugin
module.exports = {"supplierGeneralTable":"SupplierGeneral_supplierGeneralTable__2vlWf","headerWrapper":"SupplierGeneral_headerWrapper__1eK1c"};